module.exports = __webpack_public_path__ + "static/media/undraw_messaging.7b832c6c.svg";